import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import { getProjectById } from './getProjectById.api';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getProjectList(id, callback) {
	await firebaseRef.ref('/users/' + id).on('value', (snapshot) => {
		var user = snapshot.val();

		if (user) {
			var userProjects = user.projectRoles;

			var userProjectKeys = Object.keys(userProjects);

			var projectList = [];

			userProjectKeys.forEach((key) => {
				var projectId = key;

				var projectRole = userProjects[key];

				getProjectById(projectId).then((data) => {
					var projectName;
					projectName = data;
					var chipData = {
						key: projectId,
						label: projectName,
						role: projectRole,
					};

					projectList.push(chipData);
				});
			});

			Promise.all(projectList).then((data) => {
				console.log('projectList', projectList);
				callback(projectList);
			});
		}
	});
}
